import { render, staticRenderFns } from "./tjgl.vue?vue&type=template&id=65091b86&scoped=true"
import script from "./tjgl.vue?vue&type=script&lang=js"
export * from "./tjgl.vue?vue&type=script&lang=js"
import style0 from "./tjgl.vue?vue&type=style&index=0&id=65091b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65091b86",
  null
  
)

export default component.exports